import { actions, getField } from 'react-redux-form'
import isEmail from 'validator/lib/isEmail.js'
import { t, jt } from 'ttag'

export const validateForm = (formPath, validations) => form => dispatch => {
  let validationResponses = []
  /*
   * Validate all of the form fields plus the empty string, which represents
   * form level validations.  Don't use Object.keys(validations) because it won't
   * clear errors for fields that have been removed after errors occurred
   */
  /*
   * console.log("Validating form", form);
   * debugger;
   */
  const fieldKeys = ['', ...Object.keys(form)]

  fieldKeys.forEach(fieldKey => {
    let fullPath = formPath

    if (fieldKey) {
      fullPath = `${formPath}.${fieldKey}`
    }

    //console.log("Full model is", fullModel);
    const fns = validations[fieldKey] || []
    const vfn = validate(fullPath, fns)

    //console.log("Validating", fullPath, "with", fns);
    validationResponses = [...validationResponses, dispatch(vfn(form))]
  })

  return Promise.all(validationResponses).then(allResponses => {
    return allResponses.reduce((v1, v2) => v1 && v2, true)
  })
}

export const validate = (model, fns) => val => (dispatch, getState) => {
  const innerValidate = ([fn, ...rest]) => {
    if (!fn) {
      //console.log("Validation of", model, "succeeded");
      dispatch(actions.setErrors(model, {}))
      dispatch(actions.setPending(model, false))

      return Promise.resolve(true)
    }

    const ret = fn(val, getState)

    return Promise.resolve(ret)
      .then(resp => {
        if (resp) {
          //console.log("Validation of", model, "failed!", resp);
          dispatch(actions.setErrors(model, resp))
          dispatch(actions.setPending(model, false))

          return false
        }

        return innerValidate(rest)
      })
      .catch(e => {
        console.log('Unexpected validation error', e, 'for', model)
        dispatch(actions.setErrors(model, { unexpected: 'An unexpected error occurred' }))
        dispatch(actions.setPending(model, false))

        return Promise.resolve(false)
      })
  }

  //console.log("Starting validation of", model, "with", fns.length, "validators defined");
  dispatch(actions.setPending(model, true))

  return innerValidate(fns)
}

export const stringDefined = str => {
  //console.log("Running stringDefined on", typeof str, "value = ", str);
  return (
    typeof str !== 'undefined' &&
    str !== null &&
    (typeof str !== 'string' || str.trim().length > 0)
  )
}

export const targetField = (fieldName, fn) => {
  return form => {
    const val = form[fieldName]

    return fn(val)
  }
}

export const required = (params = {}) => val => {
  const { unless } = params

  if (!unless) {
    //console.log("Validating stringDefined of", val);
    return !stringDefined(val) && { required: t`Required` }
  }
}

export const minLength = params => val => {
  if (stringDefined(val)) {
    const { length } = params

    return val.length < length && { minLength: t`Minimum ${length} characters` }
  }
}

export const maxLength = params => val => {
  if (stringDefined(val)) {
    const { length } = params

    return val.length > length && { maxLength: t`Maximum ${length} characters` }
  }
}

export const minValue = params => val => {
  if (stringDefined(val)) {
    const { amount } = params
    const intValue = parseInt(val)

    return intValue < amount && { minValue: t`Must be ${value} or more` }
  }
}

export const maxValue = params => val => {
  if (stringDefined(val)) {
    const { amount } = params
    const intValue = parseInt(val)

    return intValue > amount && { maxValue: t`Must be ${value} or less` }
  }
}

export const isDate = params => val => {
  if (stringDefined(val)) {
    const d = isNaN(Date.parse(val))

    return d && { isDate: t`Invalid date` }
  }
}

export const email = params => val => {
  if (stringDefined(val)) {
    return !isEmail(val) && { email: t`Invalid e-mail address` }
  }
}

export const match = params => form => {
  const { field, against } = params
  const val = form[field]
  //console.log('againstField =', againstField);
  const againstVal = form[against]

  //console.log('val =', val, 'againstVal =', againstVal);
  return (
    stringDefined(val) &&
    stringDefined(againstVal) &&
    val !== againstVal && { match: t`Values don't match` }
  )
}
